const qcNoteFR = {
    "view": {
        "message": {
            "releaseHasQCIssues": "La sortie {{releaseName}} a des problèmes de QC, veuillez éditer la sortie pour des commentaires détaillés sur la QC, apporter les modifications nécessaires et soumettre à nouveau !",
            "trackHasQCIssues": "La piste {{trackName}} a des problèmes de QC, veuillez éditer la piste pour des commentaires détaillés sur la QC, apporter les modifications nécessaires et soumettre à nouveau !"
        }
    }
};

export default qcNoteFR;